module.exports = __webpack_public_path__ + "./images/lab.e0a840.svg";